<div>
  <div class="title mb-4">
    <h4>Campaigns</h4>
  </div>
  <!-- (focusout)="saveFormData()" -->
  <form (submit)="saveFormData()" class="mt-n1">
    <div class="row" style="padding-top: 14px">
      <div class="col-md-12">
        <div class="nm_contact">
          <div class="form-group">
            <div class="mb-3 row">
              <label for="name" class="col-sm-1 col-form-label">Name</label>
              <div class="col-sm-5">
                <input
                  [(ngModel)]="formData.name"
                  type="text"
                  placeholder="Enter name"
                  class="form-control"
                  id="name"
                  name="name"
                />
              </div>
              <label for="link" class="col-sm-1 col-form-label">Link</label>
              <div class="col-sm-5">
                <input
                  [(ngModel)]="formData.link"
                  type="text"
                  placeholder="Enter link"
                  class="form-control"
                  id="link"
                  name="link"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="mb-3 row">
              <label for="start_date" class="col-sm-1 col-form-label"
                >Start date
              </label>
              <div class="col-sm-5">
                <input
                  [(ngModel)]="formData.start_date"
                  type="date"
                  placeholder="Enter start date"
                  class="form-control"
                  id="start_date"
                  name="start_date"
                />
              </div>
              <label for="Tier" class="col-sm-1 col-form-label">Tier</label>
              <div class="col-sm-5">
                <input
                  [(ngModel)]="formData.tier"
                  type="text"
                  placeholder="Enter tier"
                  class="form-control"
                  id="Tier"
                  name="tier"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row" style="padding-top: 14px">
      <div class="col-md-12">
        <div class="nm_contact">
          <h4 class="mt-n2">Keywords</h4>
          <div class="form-group mt-1">
            <div class="mb-3 row">
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[0]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword1"
                />
              </div>
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[1]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword2"
                />
              </div>
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[2]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword3"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="mb-3 row">
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[3]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword4"
                />
              </div>
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[4]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword5"
                />
              </div>
              <div class="col-sm-4 mt-1">
                <input
                  [(ngModel)]="keywords[5]"
                  type="text"
                  placeholder="Enter keyword"
                  class="form-control"
                  name="keyword6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <button id="map_search_submit" type="submit">Submit</button>
  </form>

  <div
    *ngFor="let data of mapSearchMonthListing; let mainIndex = index"
    class="row mt-3"
  >
    <div class="col-lg-12 col-md-12">
      <h5 class="dash_subheading">Month {{ mainIndex + 1 }}</h5>
      <div class="white_box shadow p-3">
        <div class="purchase_div">
          <div class="job_plan mb-4 mt-4">
            <div class="row align-items-center">
              <div
                *ngFor="let item of data.listing; let index = index"
                class="col-xl-4 col-lg-6 col-md-12 mb-4"
              >
                <div class="card pt-3 pb-2 pl-2 pr-2">
                  <div class="d-flex">
                    <textarea
                      class="form-control mr-2"
                      rows="4"
                      [(ngModel)]="item.text"
                      placeholder="Enter Text"
                      (blur)="saveData(item)"
                    ></textarea>

                    <div class="ml-auto">
                      <div
                        *ngIf="!item.image"
                        class="select-img d-flex align-items-center justify-content-center flex-column"
                        (click)="
                          openSelectImagePopUp(
                            '.map-search-' + mainIndex + '-' + index
                          )
                        "
                      >
                        <i class="fas fa-plus"></i>
                        <p>Image</p>
                        <input
                          type="file"
                          [ngClass]="
                            'map-search-' + mainIndex + '-' + index
                          "
                          (change)="
                            saveSeletedImage($event, mainIndex, index)
                          "
                          class="d-none"
                          accept="image/*"
                        />
                      </div>
                      <img loading="lazy"
                        *ngIf="item.image"
                        height="200px"
                        width="240px"
                        class="map-search-listing-img"
                        [src]="getImagePath(item.image)"
                        (click)="viewImage(view_image, item)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="com_btn px-1 month-list-add-more"
                  (click)="addMonthList(mainIndex)"
                >
                  <i class="fas fa-plus"></i> Add more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="com_btn mt-3" (click)="addNewMonth()">
    <i class="fas fa-plus"></i> Add more
  </button>
</div>
<!-- image preview modal -->

<ng-template #view_image let-modal>
  <div class="modal-header">
    <h4 class="modal-title">View image</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body text-center">
    <di class="modal-body-container">
      <div
        class="cross-icon"
        (click)="deleteConfirmation(delete_confirmation_modal)"
      >
        <i class="fa fa-trash"></i>
      </div>
      <img loading="lazy"
        [src]="getImagePath(currentItem.image)"
        class="modal_sm_img"
        alt=""
      />
    </di>
  </div>
</ng-template>

<!-- image remove confirmation -->

<ng-template #delete_confirmation_modal let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Delete Image</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
      <div class="text-center">
        <h2 class="delete-confirm-dialog-content">
          Are you sure you want to delete the image?
        </h2>
      </div>
      <div class="text-center">
        <button class="btn btn-dark mx-auto delete-btn" (click)="deleteImage()">
          Yes
        </button>
        &nbsp; &nbsp;
        <button
          class="btn btn-dark mx-auto"
          (click)="modal.dismiss('Cross click')"
        >
          No
        </button>
      </div>
    </div>
  </div>
</ng-template>
